import { gql } from '@apollo/client';

export const PROCESS_PARTIAL_UPDATES = gql`
  mutation ProcessPartialUpdates(
    $updates: [PartialUpdateInput!]!
    $allOrNothingUpdate: Boolean!
  ) {
    processPartialUpdates(
      updates: $updates
      allOrNothingUpdate: $allOrNothingUpdate
    ) {
      successfulUpdates {
        objectId
        objectType
        attributeName
        fieldKey
        oldValue
        newValue
        success
        error {
          errorType
          message
        }
      }
      failedUpdates {
        objectId
        objectType
        attributeName
        fieldKey
        oldValue
        newValue
        success
        error {
          errorType
          message
        }
      }
    }
  }
`;
